import { StyledSvg } from './Svg.styled';
import type { SizeProps } from './types';

export const HeadphoneIcon = ({ width, height }: SizeProps) => {
	return (
		<StyledSvg
			$width={width ?? '25px'}
			$height={height ?? '28px'}
			viewBox='0 0 25 28'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M9.08969 22.7405H5.20242C4.66792 22.7405 4.21036 22.5502 3.82973 22.1696C3.4491 21.789 3.25879 21.3314 3.25879 20.7969V13.9942C3.25879 12.7794 3.4896 11.6416 3.95121 10.5807C4.41282 9.51977 5.03641 8.59655 5.82196 7.81099C6.60751 7.02544 7.53074 6.40186 8.59164 5.94024C9.65254 5.47863 10.7904 5.24783 12.0051 5.24783C13.2199 5.24783 14.3578 5.47863 15.4187 5.94024C16.4796 6.40186 17.4028 7.02544 18.1883 7.81099C18.9739 8.59655 19.5975 9.51977 20.0591 10.5807C20.5207 11.6416 20.7515 12.7794 20.7515 13.9942V20.7969C20.7515 21.3314 20.5612 21.789 20.1806 22.1696C19.7999 22.5502 19.3424 22.7405 18.8079 22.7405H14.9206V14.966H18.8079V13.9942C18.8079 12.0991 18.1478 10.4916 16.8278 9.17154C15.5077 7.85149 13.9002 7.19146 12.0051 7.19146C10.1101 7.19146 8.50255 7.85149 7.1825 9.17154C5.86245 10.4916 5.20242 12.0991 5.20242 13.9942V14.966H9.08969V22.7405ZM7.14606 16.9096H5.20242V20.7969H7.14606V16.9096ZM16.8642 16.9096V20.7969H18.8079V16.9096H16.8642Z'
				fill='#008080'
			/>
		</StyledSvg>
	);
};
